/*eslint no-unused-vars:0 */
import APICall from "../apiCall.js";
import { notificationsSlice, loadNotifications } from "../notificationsSlice.js";
import { panelsSlice } from "../panelsSlice.js";
import { realtimeSlice } from "../realtimeSlice.js";
import { relaySlice } from "../relaysSlice.js";
import { sitesSlice } from "../sitesSlice.js";
import { isClaimsValid, isSessionValid } from "./AuthFilters";

export const JWT_SET = "JWT_SET";

export function setJWT(key, token) {
    return dispatch => {
        dispatch({ type: JWT_SET, key, token });
        if(key === "claims" && token != null){
            dispatch(loadNotifications());
        }
    }
}

export function login(email, password) {
    return dispatch => {
        return APICall("/auth/login", { email, password })
            .then(data => dispatch(setJWT("session", data.token)) )
    }
}

let _tokenFetch = null;
function _fetchPanelToken(dispatch) {
    if (_tokenFetch == null) {
        _tokenFetch = APICall("/v2/claims/auth", {}, {}, "session").then(data => {
            _tokenFetch = null;
            return dispatch(setJWT("claims", data.token));
        }, err => {
            _tokenFetch = null;
            console.error("Could not fetch valid token");
            if (isSessionValid()) {
                throw err;
            } else {
                dispatch(logout());
                throw new Error("Session expired during _fetchPanelToken");
            }
        })
    }
    return _tokenFetch;
}

export function getPanelToken(force = false) {
    return dispatch => {
        if (!isSessionValid()) {
            dispatch(logout());
            throw new Error("Session expired in getPanelToken");
        }
        if (!isClaimsValid() || force) {
            return _fetchPanelToken(dispatch);
        } else {
            return Promise.resolve(true);
        }
    }

}

export function logout() {
    return dispatch => {
        dispatch(setJWT("session", null));
        dispatch(setJWT("claims", null));

        console.log({
            sitesSlice,
            panelsSlice,
            realtimeSlice,
            relaySlice,
            notificationsSlice
        })
        dispatch(sitesSlice.actions.clear());
        dispatch(panelsSlice.actions.clear());
        dispatch(realtimeSlice.actions.clear());
        dispatch(relaySlice.actions.clear());
        dispatch(notificationsSlice.actions.clear());
        
    }
}

export function register(data) {
    return dispatch => {
        return APICall("/auth/register", data)
            .then(data => {
                dispatch(setJWT("session", data.token));
            })
    }
}

export function resetPassRequest(email) {
    return APICall("/auth/resetpassword/request", { email: email })
}
export function resetPass(password, token) {
    return dispatch => {
        return APICall("/auth/resetpassword/reset", { password: password, token: token })
            .then(data => {
                dispatch(setJWT("session", data.token));
            })
    }
}

export function getAccount() {
    return APICall("/auth/account", null, {}, "session")
}

export function saveAccount(data) {
    return APICall("/auth/account", data, {}, "session")
}